import { z } from 'zod';

import type { Attachment } from '@/lib/data/domains/attachment';

export const NewGlazierInvoiceFormSchema = z
  .object({
    invoiceNumber: z.string(),
    invoiceFile: z.array(z.custom<Attachment>()),
    jobCosts: z.array(
      z.object({
        claim: z.object({
          id: z.string(),
          number: z.string(),
        }),
        cost: z.number().nullable(),
      }),
    ),
  })
  .superRefine((data, ctx) => {
    if (!data.invoiceNumber?.trim()) {
      ctx.addIssue({
        path: ['invoiceNumber'],
        message: 'Invoice number is required',
        code: 'custom',
      });
    }

    if (data.invoiceFile.length < 1) {
      ctx.addIssue({
        path: ['invoiceFile'],
        message: 'Please upload an invoice file',
        code: 'custom',
      });
    }

    if (data.jobCosts.length < 1) {
      ctx.addIssue({
        path: ['jobCosts'],
        message: 'Select at least one claim',
        code: 'custom',
      });
    }

    data.jobCosts.forEach((jobCost, index) => {
      if (!jobCost.claim.id) {
        ctx.addIssue({
          path: ['jobCosts', index, 'claim'],
          message: 'Claim is required',
          code: 'custom',
        });
      }

      if (jobCost.cost == null || jobCost.cost <= 0) {
        ctx.addIssue({
          path: ['jobCosts', index, 'cost'],
          message: 'Amount is required',
          code: 'custom',
        });
      }
    });
  });
